module.exports = __webpack_public_path__ + "img/drug-design.b7e06211.svg";